<script lang="ts" setup>
import { computed, inject } from 'vue'
import { DTFieldProvider } from '../../keys'
import type { FieldProvider } from '../../types/field'

defineProps<{
  label?: string
  labelFor?: string
}>()

const fieldProvider = inject<FieldProvider | undefined>(DTFieldProvider, undefined)
const textSize = computed(() => {
  const size = fieldProvider?.size ?? 'md'
  switch (size) {
    case 'xs':
      return 'text-xs'
    default:
      return 'text-sm'
  }
})
</script>

<template>
  <label
    v-show="label || $slots.default"
    :for="labelFor"
    class="w-max font-medium text-gray-800"
    :class="textSize"
  >
    <slot>
      {{ label }}
    </slot>
  </label>
</template>
